import React, { useState } from 'react';

const SearchBar = ({ suggestions = [], onSearch }) => {

    const [query, setQuery] = useState('');
    const [filtered, setFiltered] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const handleChange = (e) => {
        const input = e.target.value;
        setQuery(input);
        if (input.length > 0) {
            const filteredSuggestions = suggestions.filter(([key, value]) =>
                value.toLowerCase().includes(input.toLowerCase())
            );
            setFiltered(filteredSuggestions);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelect = (value) => {
        setQuery(value);
        setShowSuggestions(false);
        onSearch && onSearch(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch && onSearch(query);
        setShowSuggestions(false);
    };

    return (
        <div className="position-relative w-100">
            <form onSubmit={handleSubmit}>
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control rounded-start-5 px-3"
                        placeholder="Search..."
                        value={query}
                        onChange={handleChange}
                    />
                    <button type='submit' className="input-group-text rounded-end-5 cursor-pointer" id="basic-addon2"><i className='bi bi-search fs-5 px-4'></i></button>
                </div>
            </form>

            {showSuggestions && filtered.length > 0 && (
                <ul className="list-group position-absolute w-100 mt-1 z-1 shadow" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    {filtered.map((item, index) => (
                        <li
                            key={index}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleSelect(item[1])}
                            style={{ cursor: 'pointer' }}
                        >{item[1]}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SearchBar;